$(document).ready(function() {

  $('.bttn-next').on('click', function() {
    if ($(this).hasClass('disabled')) {
      return false;
    }
  });

  /// Hide the first option in a label group to accommodate floating label
  $('.form-label-group select option:eq(0)').each(function() {
    $(this).css('color', 'white');
  });

  $('fieldset.reference-upload .form-check input').on('click', function() {
    $('.custom-file-input').attr('disabled', false)
  });

  $('.id-docs .form-check-input').on('change', function() {
    $('fieldset.d-none').removeClass('d-none');
  })

});
